import {
  defaultDirection,
  defaultLocale,
  defaultColor,
  localeOptions,
  themeColorStorageKey,
  themeRadiusStorageKey
} from '../constants/defaultValues';
import jwt_decode from 'jwt-decode';
import moment from 'moment';
var decodeData;
export const mapOrder = (array, order, key) => {
  array.sort(function (a, b) {
    const A = a[key];
    const B = b[key];
    if (order.indexOf(`${A}`) > order.indexOf(`${B}`)) {
      return 1;
    }
    return -1;
  });
  return array;
};

// returns date as 07.06.2023
export const getDateWithFormat = () => {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; // January is 0!

  const yyyy = today.getFullYear();
  if (dd < 10) {
    dd = `0${dd}`;
  }
  if (mm < 10) {
    mm = `0${mm}`;
  }
  return `${dd}.${mm}.${yyyy}`;
};

// returns date as 07/23/2023
export const formatDate = (date) => {
  if (!date) return "";
  let formatted = new Date(date.split("T")[0]);
  formatted = new Date(formatted.getTime() - formatted.getTimezoneOffset() * -60000);
  formatted = [formatted.getMonth() + 1, formatted.getDate(), formatted.getFullYear()].join('/');
  return formatted;
}

export const getCurrentTime = () => {
  const now = new Date();
  return `${now.getHours()}:${now.getMinutes()}`;
};

export const getDirection = () => {
  let direction = defaultDirection;

  try {
    if (localStorage.getItem('direction')) {
      const localValue = localStorage.getItem('direction');
      if (localValue === 'rtl' || localValue === 'ltr') {
        direction = localValue;
      }
    }
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : getDirection -> error", error)
    direction = defaultDirection;
  }
  return {
    direction,
    isRtl: direction === 'rtl',
  };
};
export const setDirection = (localValue) => {
  let direction = 'ltr';
  if (localValue === 'rtl' || localValue === 'ltr') {
    direction = localValue;
  }
  try {
    localStorage.setItem('direction', direction);
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : setDirection -> error", error)
  }
};

export const getCurrentColor = () => {
  let currentColor = defaultColor;
  try {
    if (localStorage.getItem(themeColorStorageKey)) {
      currentColor = localStorage.getItem(themeColorStorageKey);
    }
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : getCurrentColor -> error", error)
    currentColor = defaultColor
  }
  return currentColor;
};

export const setCurrentColor = (color) => {
  try {
    localStorage.setItem(themeColorStorageKey, color);
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : setCurrentColor -> error", error)
  }
};

export const getCurrentRadius = () => {
  let currentRadius = 'rounded';
  try {
    if (localStorage.getItem(themeRadiusStorageKey)) {
      currentRadius = localStorage.getItem(themeRadiusStorageKey);
    }
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : getCurrentRadius -> error", error)
    currentRadius = 'rounded'
  }
  return currentRadius;
};
export const setCurrentRadius = (radius) => {
  try {
    localStorage.setItem(themeRadiusStorageKey, radius);
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : setCurrentRadius -> error", error)
  }
};

export const getCurrentLanguage = () => {
  let language = defaultLocale;
  try {
    language = localStorage.getItem('currentLanguage') &&
      localeOptions.filter(
        (x) => x.id === localStorage.getItem('currentLanguage')
      ).length > 0
      ? localStorage.getItem('currentLanguage')
      : defaultLocale;
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : getCurrentLanguage -> error", error)
    language = defaultLocale;
  }
  return language;
};
export const setCurrentLanguage = (locale) => {
  try {
    localStorage.setItem('currentLanguage', locale);
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : setCurrentLanguage -> error", error)
  }
};

export const getCurrentUser = () => {
  let user = null;
  try {
    user = localStorage.getItem('role') != null ? localStorage.getItem('role') : null;
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js  : getCurrentUser -> error", error)
    user = null;
  }
  return user;
}

export const setCurrentUser = (token) => {
  if (token) {
    localStorage.setItem("token", token);
    decodeData = jwt_decode(token);
    // console.log(decodeData,"this is decide data")
    localStorage.setItem("role", decodeData.role);
    localStorage.setItem("subscriptionPlanId", decodeData.subscriptionPlanId);
    localStorage.setItem("email", decodeData.email);
    localStorage.setItem("firstname", decodeData.firstname);
    localStorage.setItem("lastname", decodeData.lastname);
    localStorage.setItem("avatar", decodeData.avatar);
  } else {

    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("subscriptionPlanId");
    localStorage.removeItem("email");
    localStorage.removeItem("firstname");
    localStorage.removeItem("lastname");
    localStorage.removeItem("avatar");
  }
};

export const getUserSubscriptionPlan = () => {
  let subscriptionPlanId = null;
  try {
    subscriptionPlanId = localStorage.getItem('subscriptionPlanId') != null ? localStorage.getItem('subscriptionPlanId') : null;
  } catch (error) {
    return null;
  }
  return subscriptionPlanId;
}

export const getUserSubscriptionPlanFromToken = () => {
  let subscriptionPlanId = null;
  const Token = localStorage.getItem('token');
  if (Token) {
    try {
      const DecodeToken = jwt_decode(Token);
      subscriptionPlanId = DecodeToken.subscriptionPlanId;
    } catch (e) {
      console.error("Invalid token");
    }
  }
  return subscriptionPlanId;
};

export const thousands_separators = (num) => {
  if (num != null) {
    var num_parts = num.toString().split('.');
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return num_parts.join('.');
  }
};

export const formatWithMoment = (value) => {
  if (!value) return value;

  return moment(value)
    .format('MM/DD/YYYY h:mm A');
};